import Vue from 'vue'
import Vant from 'vant'
import notice  from '@/utils/notice'
import VueContextMenu from 'vue-contextmenu' // 右键菜单
import VueClipboard from 'vue-clipboard2'

import '@/assets/css/index.scss'
import 'vant/lib/index.css';

Vue.use(notice);
Vue.use(Vant);
Vue.use(VueContextMenu)
Vue.use(VueClipboard )


